import * as React from "react";
import { Box, Button, createTheme, Grid, IconButton, ThemeProvider, Typography } from "@material-ui/core";
import { Link, useHistory } from 'react-router-dom';
import useStyles from "../assets/styles";
import { RedirectIcon, RightArrowIcon } from "src/components/Icons";
import { clickBack } from "src/app/utils";
import { hasUserPermission } from "src/app/permission";

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});


const steps = [
  { step: "step 01", title: "SenzMatica", description: "SenzMatica is a comprehensive AIoT platform that integrates seamlessly with various AI and IoT device.", pathname:"/ConnectDataStream" },
  { step: "step 02", title: "Azure IoT", description: "Azure IoT is a robust platform that enables the connection and management of IoT devices securely", pathname:"/Azure-IoT"},
  { step: "step 03", title: "AWS IoT", description: "Coming Soon...", pathname:"" },
  { step: "step 04", title: "Rest API", description: "Coming Soon...", pathname:"" }
];

const StepCard = ({ step, title, description, pathname, disabled }) => {
  const classes = useStyles();

  const isButtonDisabled = () => {
    if (disabled) {
      return true;
    }
    switch (step) {
      case "step 01":
        return !hasUserPermission("SETUP_DEVICE_PULSE.CONNECT_DATA_STREAM.SENZMATICA", "CREATE");
      case "step 02":
        return !hasUserPermission("SETUP_DEVICE_PULSE.CONNECT_DATA_STREAM.AZURE_IOT", "CREATE");
      default:
        return false;
    }
  }

  const disabledButton = isButtonDisabled();

  return (
    <Grid item xs={12} md={12}>
      <Box className={classes.dataStreamBoxContainer}>
        <Grid item style={{display:"flex", flexDirection:"column", justifyContent:"start"}}>
          <Typography className={classes.dataStreamTitleContainer}>{title}</Typography>
          <Typography className={classes.dataStreamDescription}>{description}</Typography>
        </Grid>
        <div className={classes.buttonContainer} style={{justifyContent: "start", paddingLeft: "10px"}}>
          {disabledButton ? (
            <Button
              variant="contained"
              className={classes.testAutomationStarted}
              style={{ textTransform: "none" }}
              disabled
            >
              Get Started
              <RightArrowIcon />
            </Button>
          ) : (
            <Link to={pathname}>
              <Button
                variant="contained"
                className={classes.testAutomationStarted}
                style={{ textTransform: "none" }}
              >
                Get Started
                <RightArrowIcon />
              </Button>
            </Link>
          )}
        </div>
      </Box>
    </Grid>
  );
};

export function DataStreamComponent() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <ThemeProvider theme={theme}>
      <div className={`testing`}>
        <Grid container className={classes.pageTitleContainer}>
          <IconButton onClick={() => clickBack(history, "/TestAutomation")}>
            <RedirectIcon />
          </IconButton>
          <Grid className={classes.pageTitle} style={{margin:'0px'}}>Connect Data Stream - Step 01</Grid>
        </Grid>
        <Grid container spacing={3}
          style={{
            padding: "0px 20px 30px",
            marginTop: "10px"
          }}
        >
          {steps.map((step, index) => (
            <Grid item xs={12} md={6} key={index}>
              <StepCard step={step.step} title={step.title} description={step.description} pathname={step.pathname} disabled={index === 2 || index === 3}  />
            </Grid>
          ))}
        </Grid>
      </div>
    </ThemeProvider>
  );
}
